var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 18.75H5.625M30 3.75V11.25M15 3.75V11.25M14.625 41.25H30.375C33.5253 41.25 35.1004 41.25 36.3037 40.6369C37.3621 40.0976 38.2226 39.2371 38.7619 38.1787C39.375 36.9754 39.375 35.4003 39.375 32.25V16.5C39.375 13.3497 39.375 11.7746 38.7619 10.5713C38.2226 9.51289 37.3621 8.65238 36.3037 8.11309C35.1004 7.5 33.5253 7.5 30.375 7.5H14.625C11.4747 7.5 9.89956 7.5 8.6963 8.11309C7.63789 8.65238 6.77738 9.51289 6.23809 10.5713C5.625 11.7746 5.625 13.3497 5.625 16.5V32.25C5.625 35.4003 5.625 36.9754 6.23809 38.1787C6.77738 39.2371 7.63789 40.0976 8.6963 40.6369C9.89956 41.25 11.4747 41.25 14.625 41.25Z",
    stroke: "#383ECB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYears);
export default __webpack_public_path__ + "static/media/icon-years.c4cb269ffcc65ad34e71fa45f93db24e.svg";
export { ForwardRef as ReactComponent };